module.exports = ".message-container {\n  text-align: center;\n  padding-top: 30px;\n}"